import React, { useEffect } from "react";
import { Row, Col, Card, Button, List, Avatar, Carousel } from "antd";
import "./Home.css"; // Add your styles here
import Navigation from "../navigation/Navigation";
import { concert, equalizer, guitar, guitar2, microphone1, sanecka } from "../assets/assets";
import FooterComponent from "../footer/Footer";
import { Link, Navigate } from "react-router-dom";
import { auth } from "../../App";
import { useDispatch, useSelector } from "react-redux";
import { logPageVisit } from "../../actions/AnalyticsActions";
import { fetchArtists } from "../../actions/ArtistsActions";
import { FaDeezer } from "react-icons/fa";
import { SiApplemusic, SiAudiomack } from "react-icons/si";


import { UserOutlined, InstagramOutlined, FacebookOutlined, TwitterOutlined, MailOutlined, YoutubeOutlined, BoldOutlined, SpotifyOutlined, DeleteOutlined, ExclamationCircleOutlined, XOutlined, EyeFilled } from '@ant-design/icons';
import { TiTick, TiTickOutline } from "react-icons/ti";
import { ImTarget } from "react-icons/im";
import { RxArrowRight } from "react-icons/rx";


import youtubeSvg from '../../assets/socials/youtube.svg';
import youtubeMusicSvg from '../../assets/socials/youtubeMusic.svg';
import deezerSvg from '../../assets/socials/deezer.svg';
import audioMackSvg from '../../assets/socials/audiomack.svg';
import boomPlaySvg from '../../assets/socials/boomplay.svg';
import appleMusicSvg from '../../assets/socials/appleMusic.svg';
import amazonMusicSvg from '../../assets/socials/amazonMusic.svg';
import spotifySvg from '../../assets/socials/spotify.svg';
import { Helmet } from "react-helmet";

const icons = {
  youtubeMusicSvg,
  spotifySvg,
  appleMusicSvg,
  youtubeSvg,
  deezerSvg,
  audioMackSvg,
  boomPlaySvg,
  amazonMusicSvg
};

const Home = () => {

  const dispatch = useDispatch();
  const { translations, language } = useSelector((state) => state.language);

  const { artists, success, error } = useSelector(state => state.artists);




  useEffect(() => {
    dispatch(logPageVisit("Home"));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // if (auth.currentUser) {
  //   // if (user) {
  //   // User logged in
  //   return <Navigate to="/dashboard" />;
  // }
  // const artists = [
  //   {
  //     name: "Artist 1",
  //     image: "/path-to-artist1.jpg",
  //     socialMedia: [
  //       { platform: "Instagram", link: "https://instagram.com/artist1" },
  //       { platform: "Spotify", link: "https://spotify.com/artist1" },
  //     ],
  //   },
  //   {
  //     name: "Artist 2",
  //     image: "/path-to-artist2.jpg",
  //     socialMedia: [
  //       { platform: "YouTube", link: "https://youtube.com/artist2" },
  //       { platform: "Apple Music", link: "https://applemusic.com/artist2" },
  //     ],
  //   },
  //   // Add more artists here
  // ];

  const socialPlatforms = [
    // { key: "email", icon: <MailOutlined />, label: "Email" },
    { key: "instagram", icon: <InstagramOutlined />, label: "Instagram" },
    { key: "facebook", icon: <FacebookOutlined />, label: "Facebook" },
    { key: "twitter", icon: <XOutlined />, label: "Twitter" },
    { key: "youtube", icon: null, label: "YouTube" },
    { key: "spotify", icon: null, label: "Spotify" },
    { key: "deezer", icon: null, label: "Deezer" },
    { key: "appleMusic", icon: null, label: "Apple Music" },
    { key: "audioMack", icon: null, label: "Audiomack" },
    { key: "boomPlay", icon: null, label: "BoomPlay" },
    { key: "amazonMusic", icon: null, label: "Amazon Music" },
    { key: "youtubeMusic", icon: null, label: "Youtube Music" },
  ];

  return (
    // <div>
    //     <Navigation/>
    <div className="home">
      <Helmet>
        <title>Sanecka Brand - Elevating Music Talent</title>
        <meta name="description" content="Discover talented artists, explore new music, and connect with Sanecka Brand – the ultimate music label and production house." />
        <meta name="keywords" content="Sanecka Brand, music, artists, talent, production, Bongo Flava, Singeli" />
        <meta property="og:title" content="Sanecka Brand - Elevating Music Talent" />
        <meta property="og:description" content="Join Sanecka Brand to explore and promote rising musical talents." />
      </Helmet>
      {/* First Section: Background Image with Styled Text */}
      <div className="home-hero">
        <div className="home-hero-text">
          <h1>{translations.home.title}</h1>
          <p>{translations.home.description}</p>
          <Button type="primary" size="large"><Link to={'/talent'}>{translations.home.artistButton}</Link></Button>
        </div>
      </div>

      {/* Second Section: How It Works */}
      <div className="home-how-it-works">
        <Row gutter={32} align="middle" style={{ margin: 0 }}>
          <Col xs={24} md={12} style={{ padding: '10%' }}>
            <h2>{translations.howItWorks.title}</h2>
            <p>{translations.howItWorks.description}</p>
            <ol>
              {translations.howItWorks.steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </Col>
          <Col xs={24} md={12} className="xs-padding" >
            <img
              src={equalizer}
              alt="How It Works"
              className="home-how-it-works-image"
            />
          </Col>
        </Row>
      </div>

      {/* Third Section: Artists Section */}
      {
        artists?.length > 0 &&
        <div className="home-artists">
          <h2>{translations.artists.title}</h2>
          <Carousel autoplay>
            {artists?.map((artist, index) => (
              <Card key={index} className="artist-card">
                <Link to={`artists/${artist.username}`}>
                  <Avatar src={artist.personalPicUrl || sanecka} size={100} />
                  <h3>{artist.name}</h3>
                  <h4>{artist.genre}</h4>
                  {/* <div className="artist-socials">
                  {artist.socialMedia.map((social, idx) => (
                    <a
                      key={idx}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {social.platform}
                    </a>
                  ))}
                </div> */}
                </Link>

                <div className="artist-socials" style={{ display: "flex", gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
                  {socialPlatforms
                    .map(({ key, icon, label }) => artist[key] ? { key, icon, label, link: artist[key] } : null)
                    .filter(Boolean) // Remove null values
                    .slice(0, 5).map(({ key, icon, label, link }) => (
                      icon === null ?
                        <a
                          key={key}
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={icons[`${key}Svg`]} alt={label} width={80} height={50} className="stream-button" />
                        </a>
                        :
                        <a
                          key={key}
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "flex", alignItems: "center", gap: 5, textDecoration: "none" }}
                        >
                          {icon}
                          <span>{label}</span>
                        </a>
                    ))}
                </div>

                <Link to={`artists/${artist.username}`}>
                  <h3><EyeFilled /> {translations.artists.seeMore}</h3>
                </Link>

              </Card>
            ))}
          </Carousel>
        </div>
      }

      {/* Additional Sections */}
      <div className="home-sections">
        <section className="home-recording-studio">
          <Row gutter={32} align="middle" style={{ margin: 0 }}>
            <Col xs={24} md={12} style={{ padding: '10%' }}>
              <h2>{translations.studio.title}</h2>
              <p>{translations.studio.description}</p>
              {/* <Button type="primary">{translations.studio.button}</Button> */}
            </Col>
            <Col xs={24} md={12} className="xs-padding" >
              <img
                src={concert}
                alt="Recording Studio"
                className="home-section-image"
              />
            </Col>
          </Row>
        </section>

        <section className="home-music-promotion" style={{ padding: '10% 15%', textAlign: 'center' }}>
          <h2>{translations.musicPromotion.title}</h2>
          <p>{translations.musicPromotion.description}</p>
          <ul className="home-ul">
            <li><ImTarget color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.musicPromotion.list1}</span></li>
            <li><ImTarget color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.musicPromotion.list2}</span></li>
            <li><ImTarget color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.musicPromotion.list3}</span></li>
          </ul>
          <p>{translations.musicPromotion.description2}</p>
          {/* <Button type="primary">{translations.musicPromotion.button}</Button> */}
        </section>

        <section className="home-talent-scouting">
          <Row gutter={32} align="middle" style={{ margin: 0 }}>
            <Col xs={24} md={12} style={{ padding: '10%' }}>
              <h2>{translations.talentScouting.title}</h2>
              <p>{translations.talentScouting.description}</p>
              {/* <Button type="primary">{translations.talentScouting.button}</Button> */}
            </Col>
            <Col xs={24} md={12} className="xs-padding" >
              <img
                src={microphone1}
                alt="Talent Scouting"
                className="home-section-image"
              />
            </Col>
          </Row>
        </section>

        {/* <section className="home-event-management">
          <h2>Event Management</h2>
          <p>
            Let us help you organize concerts, tours, and fan meet-ups. From
            planning to execution, we handle it all to ensure your events are
            memorable.
          </p>
          <Button type="primary">Plan an Event</Button>
        </section> */}

        <section className="home-artist-network" style={{ padding: '10% 15%', textAlign: 'center' }}>
          <h2>{translations.artistNetwork.title}</h2>
          <p>{translations.artistNetwork.description}</p>
          <ul className="home-ul">
            <li><RxArrowRight color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.artistNetwork.list1}</span></li>
            <li><RxArrowRight color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.artistNetwork.list2}</span></li>
            <li><RxArrowRight color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.artistNetwork.list3}</span></li>
          </ul>
          <p>{translations.artistNetwork.description2}</p>
          {/* <Button type="primary">{translations.artistNetwork.button}</Button> */}
        </section>

        {/* <section className="home-merchandise">
          <h2>Merchandise and Branding</h2>
          <p>
            Create and sell your own merchandise with our design and production
            support. From t-shirts to posters, we've got you covered.
          </p>
          <Button type="primary">Start Selling</Button>
        </section> */}

        <section className="home-industry-insights" style={{ padding: '10% 15%', textAlign: 'center' }}>
          <h2>{translations.industryInsights.title}</h2>
          <p>{translations.industryInsights.description}</p>
          <ul className="home-ul">
            <li><TiTick color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.industryInsights.list1}</span></li>
            <li><TiTick color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.industryInsights.list2}</span></li>
            <li><TiTick color='var(--primary)' style={{ marginRight: '3px', minWidth: 'max-content', marginTop: '4px' }} /><span style={{ flex: 1 }}>{translations.industryInsights.list3}</span></li>
          </ul>
          <p>{translations.industryInsights.description2}</p>
          {/* <Button type="primary">{translations.industryInsights.button}</Button> */}
        </section>
      </div>
    </div>
    // </div>
  );
};

export default Home;